import { createContext } from 'farrow-pipeline';
export var RunnerContext = createContext(null);
export var useRunner = function useRunner() {
  var runner = RunnerContext.use().value;

  if (!runner) {
    throw new Error("Can't call useRunner out of scope, it should be placed in hooks of plugin");
  }

  return runner;
};